export default __webpack_public_path__ + "static/media/section4-img1.54ba43e7.png";